import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SaveSlackIntegrationInput_InputAdapter_instance1qxrj6t17r87b as SaveSlackIntegrationInput_InputAdapter_instance } from '../type/adapter/SaveSlackIntegrationInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationMutation_VariablesAdapterClass;
function SaveSlackIntegrationMutation_VariablesAdapter() {
  if (SaveSlackIntegrationMutation_VariablesAdapterClass === VOID) {
    class $ {
      serializeVariables_ffnq8g_k$(writer, value, customScalarAdapters, withDefaultValues) {
        writer.name_i73qwh_k$('input');
        obj(SaveSlackIntegrationInput_InputAdapter_instance).toJson_h31rt1_k$(writer, customScalarAdapters, value.input_1);
      }
    }
    initMetadataForObject($, 'SaveSlackIntegrationMutation_VariablesAdapter');
    SaveSlackIntegrationMutation_VariablesAdapterClass = $;
  }
  return SaveSlackIntegrationMutation_VariablesAdapterClass;
}
var SaveSlackIntegrationMutation_VariablesAdapter_instance;
function SaveSlackIntegrationMutation_VariablesAdapter_getInstance() {
  return SaveSlackIntegrationMutation_VariablesAdapter_instance;
}
//region block: init
SaveSlackIntegrationMutation_VariablesAdapter_instance = new (SaveSlackIntegrationMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SaveSlackIntegrationMutation_VariablesAdapter_instance as SaveSlackIntegrationMutation_VariablesAdapter_instance1c85g929fozri,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationMutation_VariablesAdapter.mjs.map
